import { render, staticRenderFns } from "./SuperPartnerLogin.vue?vue&type=template&id=500a70fa&scoped=true"
import script from "./SuperPartnerLogin.vue?vue&type=script&lang=js"
export * from "./SuperPartnerLogin.vue?vue&type=script&lang=js"
import style0 from "./SuperPartnerLogin.vue?vue&type=style&index=0&id=500a70fa&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a70fa",
  null
  
)

export default component.exports